import { render, staticRenderFns } from "./page-exception.vue?vue&type=template&id=eb74fa06&scoped=true&"
import script from "./page-exception.vue?vue&type=script&lang=js&"
export * from "./page-exception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb74fa06",
  null
  
)

export default component.exports